import { NavLink, Outlet, useLocation } from "react-router-dom";

import { useAuth } from "../kontext/AuthKontext";
import { FehlerGrenze } from "./FehlerGrenze";

function Navigationslink({ nach, children }: { nach: string; children: string }) {
  return (
    <NavLink
      to={nach}
      end={nach === "/"}
      className={({ isActive }) =>
        `rounded-lg px-3 py-2 text-sm font-semibold transition ${isActive ? "bg-neutral-900 text-white" : "text-neutral-700 hover:bg-neutral-100"}`
      }
    >
      {children}
    </NavLink>
  );
}

export function Layout() {
  const { benutzer, abmelden } = useAuth();
  const ort = useLocation();
  return (
    <div className="min-h-screen">
      <header className="sticky top-0 z-30 border-b border-neutral-200 bg-white/90 backdrop-blur">
        <div className="mx-auto flex h-16 max-w-[1600px] items-center gap-6 px-4 sm:px-6">
          <NavLink to="/" className="flex items-center gap-3" aria-label="AnmeldeMeister – Startseite">
            <img src="/logo.png" alt="AnmeldeMeister" className="h-5 w-auto" />
            <span className="hidden rounded bg-neutral-100 px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-neutral-600 sm:inline">
              Dokumentenprüfung
            </span>
          </NavLink>
          <nav className="flex items-center gap-1" aria-label="Hauptnavigation">
            <Navigationslink nach="/">Upload</Navigationslink>
            <Navigationslink nach="/anlagen">Anlagen</Navigationslink>
            <Navigationslink nach="/betriebe">Betriebe</Navigationslink>
          </nav>
          <div className="ml-auto flex items-center gap-3">
            <span className="hidden text-sm text-neutral-600 md:inline">{benutzer?.name}</span>
            <button type="button" onClick={abmelden} className="rounded-lg px-3 py-2 text-sm font-semibold text-neutral-700 hover:bg-neutral-100">
              Abmelden
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-[1600px] px-4 py-6 sm:px-6">
        {/* key: Nach einem Fehler setzt ein Seitenwechsel die Fehlergrenze zurück. */}
        <FehlerGrenze key={ort.pathname}>
          <Outlet />
        </FehlerGrenze>
      </main>
    </div>
  );
}
